import { routePathsByRole } from "../../../constants";

// The account types anyone can create, with every line of sign-up copy that
// changes by type: the type screen card and the note under it (`next`, or
// `nextConfirmed` once the email or mobile is confirmed), the welcome
// tagline, the email step's extra line and note, and the name step's note.
// Every type signs up with Google, email or mobile and finishes on the name
// step; `onboarding` types go on to /onboarding (athletes through the
// birthday step first), the others land on their home.
const steps = (after, alsoAdd = "") => ({
  next: `Next you sign up with Google, email or mobile and add your name${alsoAdd}, ${after}`,
  nextConfirmed: `Next you add your name${alsoAdd}, ${after}`,
});
const DETAILS_NEXT = "The code only confirms it is you. Your account details come right after.";

export const ACCOUNT_TYPES = [
  {
    key: "IS_ATHLETE", title: "Athlete", short: "athlete", onboarding: true,
    sub: "Build your CacheScore, get valued by brands and seen by recruiters.",
    tagline: "The profile that shows brands what you are worth",
    ...steps("then connect your socials and add your team. Your CacheScore starts as soon as the first data is in.", " and birthday"),
    emailLine: "You connect a social account after sign-up so your score can start.",
    emailNote: "The code confirms it is you before your account is created.",
    nameNote: "Your name appears on your public profile and on any contract. You can edit it later.",
  },
  {
    key: "IS_COACH", title: "Coach", short: "coach", onboarding: true,
    sub: "Verify your roster, share team codes and run CacheShare.",
    tagline: "Sharper roster insights and stronger NIL intelligence for your athletes",
    ...steps("then pick your sport, tier, league and team. An admin verifies your account before CacheShare and the team pages open."),
  },
  {
    key: "IS_BRAND_AGENCY", title: "Brand or agency", short: "brand",
    sub: "Discover athletes, match by fit and manage NIL deals.",
    tagline: "Find and sign the athletes that fit your brand",
    ...steps("then you land in Brand Mode: discover athletes, compare them side by side, build a shortlist with offers and save campaigns."),
    emailNote: DETAILS_NEXT,
  },
  {
    key: "IS_REP", title: "Rep or agent", short: "rep",
    sub: "Manage your athletes' profiles and negotiate their deals.",
    tagline: "Manage your athletes' profiles and deals",
    ...steps("then you get a Rep ID. Your athletes enter it in My Circle to link you, and their deals and threads open in Rep Mode."),
    emailNote: DETAILS_NEXT,
  },
  {
    key: "IS_SUPPORTER", title: "Parent, guardian or trainer", short: "supporter",
    sub: "Support an athlete's account and co-sign their deals.",
    tagline: "Support an athlete on CACHE",
    ...steps("then an athlete adds you to their Circle, so you see what they share with you and can co-sign contracts for a minor."),
    emailNote: DETAILS_NEXT,
  },
];

export const isAccountType = (key) => ACCOUNT_TYPES.some((t) => t.key === key);

// The type for `key`, or the athlete type when there is none yet.
export const accountTypeOf = (key) => ACCOUNT_TYPES.find((t) => t.key === key) || ACCOUNT_TYPES[0];

// The type whose /register/ role value is `value` ("1", 10...), or null.
export const accountTypeForRole = (value) =>
  ACCOUNT_TYPES.find((t) => String(routePathsByRole[t.key].value) === String(value))?.key || null;

// "an" before "athlete", "a" before "coach".
export const articleFor = (word) => (/^[aeiou]/i.test(word) ? "an" : "a");
